import {useEffect, useState} from "react";
import {CheckIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsSetUserPermissionsModal = (props: { active: boolean, closeHandler: any, id: number }) => {
    const [data, setData] = useState({
        firstname: '',
        lastname: '',
        dashboardCharts: false,
        studentsList: false,
        studentDetails: false,
        addEditStudent: false,
        downloadStudents: false,
        removeStudent: false,
        finance: false,
        financeLogs: false,
        tuition: false,
        reminders: false,
        classes: false,
        addEditClass: false,
        assignClassStudent: false,
        attend: false,
        point: false,
        sciCenter: false,
        sciAddEditClass: false,
        sciSetPaid: false,
        extraPayments: false,
        extraPaymentsAddEdit: false,
        news: false,
        newsAddEdit: false,
        consents: false,
        consentsAddEdit: false,
        tickets: false,
        users: false,
        staff:false,
        settings:false,
        presignup:false,
        site:false,
        accounting:false,
        bayan:false,
        taskCats:false,
        consult:false,
    });
    const fetchData = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/users/get',
            {
                id: props.id.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string,
                firstname: string,
                lastname: string
                dashboardCharts: 0 | 1,
                studentsList: 0 | 1,
                studentDetails: 0 | 1,
                addEditStudent: 0 | 1,
                downloadStudents: 0 | 1,
                removeStudent: 0 | 1,
                finance: 0 | 1,
                financeLogs: 0 | 1,
                tuition: 0 | 1,
                reminders: 0 | 1,
                classes: 0 | 1,
                addEditClass: 0 | 1,
                assignClassStudent: 0 | 1,
                attend: 0 | 1,
                point: 0 | 1,
                sciCenter: 0 | 1,
                sciAddEditClass: 0 | 1,
                sciSetPaid: 0 | 1,
                extraPayments: 0 | 1,
                extraPaymentsAddEdit: 0 | 1,
                news: 0 | 1,
                newsAddEdit: 0 | 1,
                consents: 0 | 1,
                consentsAddEdit: 0 | 1,
                tickets: 0 | 1,
                users: 0 | 1,
                staff:0|1,
                settings:0|1,
                presignup:0|1,
                site:0|1,
                accounting:0|1,
                bayan:0|1,
                taskCats:0|1,
                consult:0|1,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if (d.reason === 'not-found') {
                        ShowSnackbar(
                            'برای این کاربر هنوز دسترسی وجود ندارد.',
                            'باشه',
                            5000,
                        );
                        props.closeHandler();
                    } else if (d.reason === 'access') {
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        props.closeHandler();
                    }
                    return;
                }
                setData({
                    users: d.users === 1,
                    addEditClass: d.addEditClass === 1,
                    addEditStudent: d.addEditStudent === 1,
                    assignClassStudent: d.assignClassStudent === 1,
                    attend: d.attend === 1,
                    classes: d.classes === 1,
                    consents: d.consents === 1,
                    consentsAddEdit: d.consentsAddEdit === 1,
                    dashboardCharts: d.dashboardCharts === 1,
                    downloadStudents: d.downloadStudents === 1,
                    extraPaymentsAddEdit: d.extraPaymentsAddEdit === 1,
                    extraPayments: d.extraPayments === 1,
                    finance: d.finance === 1,
                    financeLogs: d.financeLogs === 1,
                    lastname: d.lastname,
                    news: d.news === 1,
                    firstname: d.firstname,
                    newsAddEdit: d.newsAddEdit === 1,
                    point: d.point === 1,
                    reminders: d.reminders === 1,
                    removeStudent: d.removeStudent === 1,
                    sciAddEditClass: d.sciAddEditClass === 1,
                    sciCenter: d.sciCenter === 1,
                    sciSetPaid: d.sciSetPaid === 1,
                    studentDetails: d.studentDetails === 1,
                    studentsList: d.studentsList === 1,
                    tuition: d.tuition === 1,
                    tickets: d.tickets === 1,
                    staff: d.staff === 1,
                    settings: d.settings === 1,
                    presignup: d.presignup === 1,
                    site: d.site === 1,
                    accounting: d.accounting === 1,
                    bayan: d.bayan === 1,
                    taskCats: d.taskCats === 1,
                    consult: d.consult === 1,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            fetchData();
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const x = {...data};
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/users/permission',
            {
                id: props.id.toString(),
                dashboardCharts: x.dashboardCharts ? '1' : '0',
                studentsList: x.studentsList ? '1' : '0',
                studentDetails: x.studentDetails ? '1' : '0',
                addEditStudent: x.addEditStudent ? '1' : '0',
                downloadStudents: x.downloadStudents ? '1' : '0',
                removeStudent: x.removeStudent ? '1' : '0',
                finance: x.finance ? '1' : '0',
                financeLogs: x.financeLogs ? '1' : '0',
                tuition: x.tuition ? '1' : '0',
                reminders: x.reminders ? '1' : '0',
                classes: x.classes ? '1' : '0',
                addEditClass: x.addEditClass ? '1' : '0',
                assignClassStudent: x.assignClassStudent ? '1' : '0',
                attend: x.attend ? '1' : '0',
                point: x.point ? '1' : '0',
                sciCenter: x.sciCenter ? '1' : '0',
                sciAddEditClass: x.sciAddEditClass ? '1' : '0',
                sciSetPaid: x.sciSetPaid ? '1' : '0',
                extraPayments: x.extraPayments ? '1' : '0',
                extraPaymentsAddEdit: x.extraPaymentsAddEdit ? '1' : '0',
                news: x.news ? '1' : '0',
                newsAddEdit: x.newsAddEdit ? '1' : '0',
                consents: x.consents ? '1' : '0',
                consentsAddEdit: x.consentsAddEdit ? '1' : '0',
                tickets: x.tickets ? '1' : '0',
                users: x.users ? '1' : '0',
                staff:x.staff ? '1':'0',
                settings:x.settings ? '1' : '0',
                presignup:x.presignup ? '1' : '0',
                site:x.site ? '1' : '0',
                accounting:x.accounting ? '1' : '0',
                bayan:x.bayan ? '1' : '0',
                taskCats:x.taskCats ? '1' : '0',
                consult:x.consult ? '1' : '0',
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if (d.reason === 'access') {
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        props.closeHandler();
                    }
                    return;
                }
                props.closeHandler();
                ShowSnackbar(
                    'دسترسی ذخیره شد.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-big" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>{"تعیین دسترسی " + data.firstname + " " + data.lastname}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <button className={"techaran-checkbox" + (data.dashboardCharts ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.dashboardCharts = !x.dashboardCharts;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>چارت های داشبورد</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.studentsList ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.studentsList = !x.studentsList;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>لیست دانش‌آموزان</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.studentDetails ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.studentDetails = !x.studentDetails;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>جزئیات دانش‌آموزان</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.addEditStudent ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.addEditStudent = !x.addEditStudent;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>افزودن و ویرایش دانش‌آموزان</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.downloadStudents ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.downloadStudents = !x.downloadStudents;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>خروجی اکسل دانش‌‌آموزان</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.removeStudent ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.removeStudent = !x.removeStudent;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>حذف دانش‌آموز</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.finance ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.finance = !x.finance;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>امورمالی</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.financeLogs ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.financeLogs = !x.financeLogs;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>سابقه عملیات مالی</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.tuition ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.tuition = !x.tuition;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>شهریه</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.reminders ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.reminders = !x.reminders;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>یادآوری‌های شهریه</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.classes ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.classes = !x.classes;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>کلاس‌ها</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.users ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.users = !x.users;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>کاربران</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.staff ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.staff = !x.staff;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>کارمندان</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.settings ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.settings = !x.settings;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>تنظیمات</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.presignup ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.presignup = !x.presignup;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>پیش ثبت‌نام</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.accounting ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.accounting = !x.accounting;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>حسابداری</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.taskCats ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.taskCats = !x.taskCats;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>دسته‌بندی کارتابل</span>
                                    </button>
                                </div>
                                <div className="col-md-6">
                                    <button className={"techaran-checkbox" + (data.addEditClass ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.addEditClass = !x.addEditClass;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>افزودن و ویرایش کلاس‌ها</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.assignClassStudent ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.assignClassStudent = !x.assignClassStudent;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>کلاس‌بندی دانش‌آموزان</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.attend ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.attend = !x.attend;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>بخش حضورغیاب دانش‌آموزی</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.point ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.point = !x.point;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>بوفه</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.sciCenter ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.sciCenter = !x.sciCenter;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>کلاس فوق‌برنامه</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.sciAddEditClass ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.sciAddEditClass = !x.sciAddEditClass;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>افزودن و ویرایش کلاس فوق‌برنامه</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.sciSetPaid ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.sciSetPaid = !x.sciSetPaid;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>پرداخت دستی کلاس فوق‌برنامه</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.extraPayments ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.extraPayments = !x.extraPayments;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>پرداخت های متفرقه</span>
                                    </button>
                                    <button
                                        className={"techaran-checkbox" + (data.extraPaymentsAddEdit ? ' active' : '')}
                                        onClick={() => setData(v => {
                                            let x = {...v};
                                            x.extraPaymentsAddEdit = !x.extraPaymentsAddEdit;
                                            return x;
                                        })}>
                                        <i><CheckIcon/></i>
                                        <span>افزودن و ویرایش پرداخت متفرقه</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.consents ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.consents = !x.consents;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>رضایت‌نامه ها</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.consentsAddEdit ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.consentsAddEdit = !x.consentsAddEdit;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>افزودن و ویرایش رضایت‌نامه</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.tickets ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.tickets = !x.tickets;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>تیکت</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.news ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.news = !x.news;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>اطلاعیه‌ها</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.newsAddEdit ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.newsAddEdit = !x.newsAddEdit;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>افزودن و ویرایش اطلاعیه</span>
                                    </button>
                                    <button className={"techaran-checkbox" + (data.site ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.site = !x.site;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>ویرایش مطالب وبسایت</span>
                                    </button>
                                    {/*<button className={"techaran-checkbox" + (data.bayan ? ' active' : '')}*/}
                                    {/*        onClick={() => setData(v => {*/}
                                    {/*            let x = {...v};*/}
                                    {/*            x.bayan = !x.bayan;*/}
                                    {/*            return x;*/}
                                    {/*        })}>*/}
                                    {/*    <i><CheckIcon/></i>*/}
                                    {/*    <span>آموزشگاه بیان</span>*/}
                                    {/*</button>*/}
                                    <button className={"techaran-checkbox" + (data.consult ? ' active' : '')}
                                            onClick={() => setData(v => {
                                                let x = {...v};
                                                x.consult = !x.consult;
                                                return x;
                                            })}>
                                        <i><CheckIcon/></i>
                                        <span>مشاوره</span>
                                    </button>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-center"
                                 style={{marginTop: 20, gap: 5}}>
                                <button className="cancel-button" onClick={props.closeHandler}>
                                    <b>انصراف</b>
                                </button>
                                <button className="btn-pay" onClick={saveChanges}>
                                    <b>ذخیره دسترسی</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};